import { useEffect, useState } from "react";
import { userData, selectedOptic } from "../js/utils";
import { post } from "../js/post";

export function useCampaigns({
  incluirCampanasCRM = true,
  incluirCampanasCRMSoloActivas = true,
} = {}) {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("/ListarCampanas.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      incluirCampanasCRM,
      incluirCampanasCRMSoloActivas,
    });
    setList([...response.map((e) => ({ id: e, text: e }))]);
  }

  useEffect(() => {
    getData();
  }, [incluirCampanasCRM, incluirCampanasCRMSoloActivas]);

  return list;
}
